import { Box, Typography } from '@mui/material';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import './PresetCard.css';

interface PresetCardProps {
  id: string;
  label: string;
  isActive: boolean;
  bg?: string;
  textColor?: string;
  onClick?: () => void;
}

const PresetCard = ({ id, label, isActive, bg, textColor, onClick }: PresetCardProps) => {
  const muiTheme = useMuiTheme();
  const isCustom = id === 'custom';
  return (
    <Box
      className={`preset-card${!isCustom ? ' preset-card--clickable' : ''} ${isCustom ? 'preset-card--custom' : ''}`}
      onClick={!isCustom ? onClick : undefined}
      style={{
        background: isCustom ? undefined : bg,
        outline: isActive ? `2px solid ${muiTheme.palette.primary.main}` : undefined,
      }}
    >
      <Typography
        variant="caption"
        className="preset-card__label"
        style={{ color: isCustom ? undefined : textColor }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default PresetCard;
